import React from "react";
import { Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import CONFIG from "../../../../utils/config";
import { isCurrentTeamStepDisabled } from "../../../../utils/functions";

function StepButton({
  teamObject,
  currentStep,
  isStepLoading,
  prev,
  next,
  preview,
  handleCancel,
}) {
  const {
    LABELS: {
      NOTIFICATIONS: { PREV, NEXT, CANCEL, SAVE, PREVIEW },
    },
  } = CONFIG;

  const { teamType } = teamObject;

  const disabledObj = isCurrentTeamStepDisabled(currentStep, teamObject);

  return (
    <div className="footer-btns">
      {currentStep !== 0 && (
        <Button className="primary-outline" onClick={() => prev()}>
          {PREV}
        </Button>
      )}
      {currentStep === 1 && teamType === "Salesforce" && (
        <Button
          className="primary-solid position-relative"
          onClick={() => preview()}
          disabled={disabledObj.next || disabledObj.save || isStepLoading}
        >
          {PREVIEW}
        </Button>
      )}
      <Button
        className="primary-solid position-relative"
        onClick={() => next()}
        disabled={disabledObj.next || disabledObj.save || isStepLoading}
      >
        {currentStep === 1 || currentStep === 2 ? SAVE : NEXT}
        {isStepLoading && <LoadingOutlined className="loading" />}
      </Button>
      {currentStep === 0 && (
        <Button
          className="primary-outline"
          onClick={() => handleCancel()}
          disabled={isStepLoading}
        >
          {CANCEL}
        </Button>
      )}
    </div>
  );
}

export default StepButton;
